// extracted by mini-css-extract-plugin
export default {"advance":"advancedWindow_advance__7p1Tq"};